import { Icon } from "antd";

const TimelineStep = ({
    icon,
    title,
    description,
    status,
    isLast = false,
    showLine = true,
    customColor = null,
    additionalInfo = null,
    timestamp = null
}) => {
    const getStatusColor = () => {
        // Si hay un color personalizado y el estado es 'completed' o 'inProgress', usarlo
        if (customColor && (status === 'completed' || status === 'inProgress')) {
            return customColor;
        }

        switch (status) {
            case 'completed':
                return '#4caf50';
            case 'inProgress':
                return '#2196f3';
            case 'canceled':
                return '#ef4444';
            default:
                return '#e0e0e0';
        }
    };

    const getStatusText = () => {
        switch (status) {
            case 'completed':
                return 'Completado';
            case 'inProgress':
                return 'En curso';
            case 'canceled':
                return 'Cancelado';
            default:
                return 'Pendiente';
        }
    };

    return (
        <div style={{
            position: 'relative',
            marginBottom: isLast ? '0' : '50px',
            minHeight: '36px'
        }}>
            {/* Círculo con icono */}
            <div style={{
                position: 'absolute',
                left: '-50px',
                top: '0',
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                backgroundColor: getStatusColor(),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '3px solid white',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
                <Icon
                    type={icon}
                    style={{
                        color: 'white',
                        fontSize: '14px',
                        display: 'flex',
                        position: 'absolute',
                        top: '25%'
                    }}
                />
            </div>

            {/* Contenido */}
            <div style={{ paddingLeft: '0' }}>
                <div style={{
                    fontWeight: 'bold',
                    fontSize: '16px',
                    lineHeight: '1.5',
                    color: status === 'canceled' ? '#ef4444' : 'inherit'
                }}>
                    {title}
                </div>
                {timestamp && (
                    <div style={{ color: '#999', fontSize: '12px', marginTop: '2px', fontWeight: '400' }}>
                        {timestamp}
                    </div>
                )}
                {additionalInfo && (
                    <div style={{ color: '#666', fontSize: '13px', marginTop: '4px', lineHeight: '1.6' }}>
                        {additionalInfo}
                    </div>
                )}
                <div style={{ color: '#666', fontSize: '14px' }}>
                    {description}
                </div>
                <div style={{
                    marginTop: '4px',
                    color: getStatusColor(),
                    fontSize: '12px',
                    fontWeight: '600'
                }}>
                    {getStatusText()}
                </div>
            </div>
        </div>
    );
};

export default TimelineStep;
